export enum Regex {
    Password = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*=+-.\\[\\]\\(\\)\\{\\}"\',:;><\\|\\/_~\\\\`]).{10,}$',
    Email = '^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$'
}
